<template>
  <div>
    <div class="panal mt-20">
      <div class="panal-header">New Request</div>
      <div class="panal-body">
          

      <b-form   @submit.prevent="onSubmit2" v-if="show" method="post">

            
            <div class="row">
        
            <div class="col-12 col-md-6 mb-1">
              

<b-form-group id="input-group-1" label="Your Name:" label-for="input-1">
        <b-form-input
          id="input-1"
          v-model="form.name"
          placeholder="Enter name"
          required 
          class="form-control su-border"
        ></b-form-input>
 </b-form-group>

            </div>


                <div class="col-12 col-md-6 mb-1">
 <b-form-group id="input-group-3" label="NationalID:" label-for="input-3">
        <b-form-input
          id="input-3"
          v-model="form.nationalID"
          placeholder="Enter NationalID"
          type="number"
          required class="form-control su-border"
        ></b-form-input>
      </b-form-group>


            </div>

            <div class="col-12 col-md-6 mb-1">
        

<b-form-group id="input-group-2" label="Your Phone:" label-for="input-2">
        <b-form-input
          id="input-2"
          v-model="form.phoneNumber"
          placeholder="Enter phone"
          type="number"
        
          required 
          class=" su-border form-control"
        ></b-form-input>
      </b-form-group>


            </div>

            <div class="col-12 col-md-6 mb-1">
 <b-form-group id="input-group-4" label="Email:" label-for="input-4">
        <b-form-input
          id="input-4"
          v-model="form.email"
          placeholder="Enter Your Email"
          type="text"
          required class="form-control su-border"
        ></b-form-input>
      </b-form-group>


            </div>
                <div class="col-12 col-md-6 mb-1">
 <b-form-group id="input-group-5" label="BirthDate:" label-for="input-5">
        <b-form-input
          id="input-5"
          v-model="form.birthDate"
          placeholder="Enter Your Birthdate"
          type="date"
          required class="form-control su-border"
        ></b-form-input>
      </b-form-group>


            </div>


                            <div class="col-12 col-md-6 mb-1">
 <b-form-group id="input-group-6" label="Address:" label-for="input-6">

        <b-form-input
          id="input-6"
          v-model="form.addresss"
          placeholder="Enter Your Address"
          type="text"
          required class="form-control su-border"
        ></b-form-input>
      </b-form-group>


            </div>

<div  class="col-12 col-md-6 mb-1">

<b-form-group id="input-group-7" label="Where did you hear about us
:" label-for="input-7">
        <b-form-select
          id="input-7"
          v-model="form.hearAboutUs"
         
          required
       
        >
         <option v-for="h in About" :key="h.Serial" :value="h.Serial">
         {{h.NameEN}}
          </option>
        </b-form-select>
      </b-form-group>

        </div>


       
                            <div class="col-12 col-md-6 mb-1">
 <b-form-group id="input-group-10" label="Current school
:" label-for="input-10">

        <b-form-input
          id="input-10"
          v-model="form.currentSchool"
          placeholder="Enter Your School"
          type="text"
          required class="form-control su-border"
        ></b-form-input>
      </b-form-group>


            </div> 

        <div  class="col-12 col-md-6 mb-1">

<b-form-group id="input-group-8" label="High school certificate Group
:" label-for="input-8">
        <!-- <b-form-select
          id="input-8"
          v-model="form.Group"
          :options="Group"
          required
       
        ></b-form-select> -->

          <b-form-select id="input-8" name="certiﬁcateGroup"  v-model="form.certiﬁcateGroup" @change="certiﬁcateGroupFunction()">
         
         

           <option v-for="g in certiﬁcateGroup" :key="g.Serial" :value="g.Serial">
         {{g.GroupNameEN}}
       </option>

          </b-form-select>
      </b-form-group>

        </div>
          <div  class="col-12 col-md-6 mb-1">

<b-form-group id="input-group-9" label="High school certificate 
:" label-for="input-9">
        <b-form-select
          id="input-9"
          v-model="form.highSchoolCertificate"
       
     
       
        >
         <option v-for="c in certiﬁcate" :key="c.GroupID" :value="c.serial">
         {{c.CertificationNameEN}}
       </option>
      
        
        </b-form-select>
      </b-form-group>

        </div>

        <h6 class="ml-3">Faculties interested in </h6>



<!-- <--test --> 

  <b-form-group id="input-group-11" v-slot="{ ariaDescribedby }">
        <b-form-checkbox-group
          v-model="form.FacultiesInterestedIN"
          id="checkboxes-11"
          :aria-describedby="ariaDescribedby"
        >
     <div class="row mb-3">
<div class="col-md-2"></div>
<div class="col-md-5" v-for="camp in campFac" :key="camp.BranchSerial">
<div class="border">
    <div class="title">{{camp.BrancheNameEN}} Branch 
</div>
  
<div class="row p-2">
<div class="col-md-12">
 <b-form-checkbox  v-for="f in camp.faculties" :key="f.BranchId"  :value="f.FacultyBranchID" class="col-12" @change="FacultiesInsert(f.FacultyBranchID)"> {{f.FacultyNameEN}}</b-form-checkbox> 

   </div>
   
</div>

</div>
</div>

</div>
</b-form-checkbox-group>
      </b-form-group>


<!-- <--test --> 
<!-- 
   <b-form-group id="input-group-11" >
        <b-form-checkbox-group
          v-model="form.FacultiesInterestedIN"
          id="checkboxes-11"
         
        >
     <div class="row mb-3">
<div class="col-md-1"></div>


<div class="col-md-5">
<div class="border">
    <div class="title">Arish Branch 
</div>
   
<div class="row p-2">
<div class="col-md-12">
 <b-form-checkbox  v-for="f in FacultiesInterestedINOne" :key="f.BranchId"  :value="f.FacultyBranchID"> {{f.FacultyNameEN}}</b-form-checkbox> 

  
       
   </div>


</div>

</div>
</div>

<div class="col-md-5">
<div class="border">
    <div class="title">Kantra Branch 
</div>
   <div class="row p-2">
<div class="col-md-12">
     
  <b-form-checkbox  v-for="f in FacultiesInterestedINTwo" :key="f.BranchId"  :value="f.FacultyBranchID"> {{f.FacultyNameEN}}</b-form-checkbox> 
  
  
       
   </div>


</div>
</div>
</div>
<div class="col-md-1"></div>


</div>
</b-form-checkbox-group>
      </b-form-group> -->



      
        <div  class="col-12 col-md-6 mb-1">

<b-form-group id="input-group-11" label="Request Type

:" label-for="input-11">
        <b-form-select
          id="input-11"
          v-model="form.serial"
          
         
          required
       
        >
<option v-for="typelist in inquiryType" :key="typelist.Serial" :value="typelist.Serial">
         {{typelist.TypeEN}}
       </option>
        
        
        
        
        </b-form-select>
      </b-form-group>

        </div>



<div class="col-12 col-md-12 mb-1">
 <b-form-group id="input-group-12" label="Request .............
:" label-for="input-12">

        <b-form-textarea
          id="input-12"
          v-model="form.questionText"
          placeholder="Enter Your Request"
          type="textarea"
          rows="3"
      max-rows="6"
          required class="form-control su-border"
        ></b-form-textarea>
      </b-form-group>


            </div>



            

            <div class="text-center col-12 mt-2">
              <b-button type="submit" variant="primary">Done</b-button>
            </div>
         
        </div>
         </b-form>



<!-- <div>  Output: {{ message.response.data}}</div> -->


      </div>
    </div>
  </div>
</template>




          <script>
         
import EventService from '../../services/Event/event.services';
 import Vue from 'vue'
// import axios from 'axios'

// Vue.use(axios)  
import VueSimpleAlert from "vue-simple-alert";

Vue.use(VueSimpleAlert);

export default {
 
  name: "NewRequest",
 
  data() {
    return {
      output:'',
       campusData: [],
       campFac : [],
       certiﬁcateGroup:'',
         certiﬁcate:'',
           About:[],
           inquiryType:'',
form: {
   campFac : [],
    campusData: [],
       
          name: '',
          phoneNumber: '',
           nationalID: '',
           addresss:'',
           email:'',
           currentSchool:'',
           birthDate:'',
           questionText:'',
           checked: [],
           hearAboutUs:[],
           certiﬁcateGroup:'',
           certiﬁcate:'',
           About:[],
         FacultiesInterestedIN:[],
           serial:[],
            // FacultiesInterestedINTwo:[],
            // FacultiesInterestedINOne:[],


          
          
        },
    //  About: [ 'facebook', 'internet', 'magazine', 'Maybe'],
        // Group: [{ text: 'Select One', value: null }, 'A', 'AB', 'ABC', 'Maybe'],
        // certificate: [{ text: 'Select One', value: null }, 'A', 'AB', 'ABC', 'Maybe'],
        // RequestType: [{ text: 'Select One', value: null }, 1, 2, 3, 4],
        show: true



    };
    
  },
  
   created() {
    EventService.Admission_SelectAllCertificationTypeByGroup(this.GroupID).then(Response =>{
     


             //  this.isLoading = false ;
               this.certiﬁcate= Response.data
               //this.empty =false
                // eslint-disable-next-line no-console
               // console.log('certiﬁcate Group => ',this.certiﬁcateGroup)
           }, error => {
             // this.empty = true
                  // eslint-disable-next-line no-console
                 // console.log(error.response.status)
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            }) 
          
EventService.SelectAllCertificationGroups().then(Response =>{
             //  this.isLoading = false ;
               this.certiﬁcateGroup = Response.data
               //this.empty =false
                // eslint-disable-next-line no-console
               // console.log('certiﬁcate Group => ',this.certiﬁcateGroup)
           }, error => {
             // this.empty = true
                  // eslint-disable-next-line no-console
                 // console.log(error.response.status)
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            }) 

          //     EventService.FacultyActiveByBranchAPI(1).then(Response =>{
          //    //  this.isLoading = false ;
          //      this.FacultiesInterestedINOne= Response.data
          //      //this.empty =false
          //       // eslint-disable-next-line no-console
          //      // console.log('certiﬁcate Group => ',this.certiﬁcateGroup)
          //  }, error => {
          //    // this.empty = true
          //         // eslint-disable-next-line no-console
          //        // console.log(error.response.status)
                 
          //     this.message =
          //       (error.response && error.response.data && error.response.data.Message) ||
          //       error.message ||
          //       error.toString();
                
          //       if(error.response.status == 404) this.message =''
             
          //   }) 



          //   EventService.FacultyActiveByBranchAPI(2).then(Response =>{
          //    //  this.isLoading = false ;
          //      this.FacultiesInterestedINTwo= Response.data
          //      //this.empty =false
          //       // eslint-disable-next-line no-console
          //      // console.log('certiﬁcate Group => ',this.certiﬁcateGroup)
          //  }, error => {
          //    // this.empty = true
          //         // eslint-disable-next-line no-console
          //        // console.log(error.response.status)
                 
          //     this.message =
          //       (error.response && error.response.data && error.response.data.Message) ||
          //       error.message ||
          //       error.toString();
                
          //       if(error.response.status == 404) this.message =''
             
          //   }) 

 EventService.SelectAllCampus().then(Response =>{
              this.campusData = Response.data;
                 this.campusData.forEach((campus,index)=> {
                 EventService.FacultyActiveByBranchAPI(campus.BranchSerial).then(result =>{
                   this.campusData[index].faculties = result.data
                   
                 })
                
            })

            }).finally(()=>{
             
             setTimeout(()=>{
           this.campFac =  this.campusData 
                  this.Loading = false ;
                  //  console.log("ca,p ",this.campFac)
             },2000)
            })

            
    EventService.GetAllRequestTypeBYCaller(1).then(Response =>{
             //  this.isLoading = false ;
               this.inquiryType= Response.data
               //this.empty =false
                // eslint-disable-next-line no-console
               // console.log('certiﬁcate Group => ',this.certiﬁcateGroup)
           }, error => {
             // this.empty = true
                  // eslint-disable-next-line no-console
                 // console.log(error.response.status)
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            }) 

              






 
 },
  mounted(){





  EventService.GetAllHearAboutUs().then(Response =>{
             //  this.isLoading = false ;
               this.About= Response.data
               //this.empty =false
                // eslint-disable-next-line no-console
               // console.log('certiﬁcate Group => ',this.certiﬁcateGroup)
           }, error => {
             // this.empty = true
                  // eslint-disable-next-line no-console
                 // console.log(error.response.status)
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            }) 



   

  },

      methods: {
certiﬁcateGroupFunction:function() {
      //this.highSchoolCertificate =  event.target.value;
            EventService.Admission_SelectAllCertificationTypeByGroup(this.form.certiﬁcateGroup).then(Response =>{
             //  this.isLoading = false ;
               this.certiﬁcate= Response.data
               //this.empty =false
                // eslint-disable-next-line no-console
               // console.log('certiﬁcate Group => ',this.certiﬁcateGroup)
           }, error => {
             // this.empty = true
                  // eslint-disable-next-line no-console
                 // console.log(error.response.status)
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            }) 

    },

    reloadPage() {
      window.location.reload();
    },
     onSubmit(event) {
        event.preventDefault()
        alert(JSON.stringify(this.form)),
        
        window.location.reload();
      },

onSubmit2(e) {

//name=h&nationalID=123456456921&userID=10&phoneNumber=1425863&email=eng%40gmail.com&addresss=fghghh&birthDate=02%2F02%2F1989&FacultiesInterestedIN=1&FacultiesInterestedIN=2&hearAboutUs=1&highSchoolCertificate=1&currentSchool=hgjgh&questionText=ghghghgh&serial=2
EventService.OnlineBasicDataInsert(this.form.name , this.form.nationalID  , 10 , this.form.phoneNumber , this.form.email  , this.form.addresss  , this.form.birthDate  , this.form.hearAboutUs, this.form.highSchoolCertificate , this.form.currentSchool , this.form.questionText , this.form.serial , this.form.FacultiesInterestedIN ).then(Response =>{
  this.FacultiesInterestedIN = []
          this.message=Response.data
          this.successful =true,
          this.$alert("Your ReQuest Number "+ Response.data).then(() => {
  window.location.reload();
});
          
         
     
        }, error => {
          this.empty =false
          this.successful =false
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                this.$alert("This basic data already exist");
            });  




       
          e.preventDefault();
               // window.location.reload();

     }

     
   

  },

};

</script>

<style scoped>
h1 {
  color: #285475;
  font-size: 25px;
  border-bottom: 1px #646464 dashed;
  padding: 10px 0px;
}
h1 a {
  color: #ff8600;
}
table tr th {
  background-color: #4caf5000 !important;
  color: #333;
  font-weight: bold;
}

.panal {
  background: #fff;
  border-radius: 10px;
  color: #fff;
  padding: 0px 0px 20px 0px;
  margin: 10px 0;
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  margin-bottom: 20px !important;
}
.panal-header {
  background: #285475;
  color: #ffffff;
  text-align: left;
  border-radius: 10px 0px 0px 0px;
  padding: 10px 20px;
  font-size: 17px;
  font-weight: bold;
  width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}

.divider {
  *width: 100%;
  height: 1px;
  margin: 9px 1px;
  *margin: -5px 0 5px;
  overflow: hidden;
  /* background-color: #e5e5e5; */
  border-bottom: 1px dotted #e5e5e5;
}
.su-border {
  border-color: #3d8fe3 !important;
  background: #f1f9ff !important;
}
.panal-body {
  padding: 20px;
  color: #333;
}
.app-stu-photo {
  float: right;
  width: 200px;
  border-radius: 10px;
  border: 1px solid #111;
  margin-top: 20px;
}
.app-stu-photo img {
  width: 100%;
  border-radius: 10px;
}
.app-All {
  width: 80%;
  float: left;
}
.app-stu {
  border-bottom: 1px #333 dotted;
  padding: 10px 0px;
}
.app-stu .title {
  font-weight: bold;
}

.app-stu .title span {
  font-weight: 100;
}

.table .thead-light th {
  font-size: 14px !important;
}
.table .thead-light th {
  font-size: 14px !important;
  background-color: #eaeaea !important;
}

.panal2 {
  background: #eee;
  border-radius: 10px;
  color: #333;
  padding: 0px 0px 20px 0px;
  margin: 10px 0;
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  margin-bottom: 20px !important;
}
.panal-header2 {
  background: #285475;
  color: #ffffff;
  text-align: left;
  border-radius: 10px 0px 0px 0px;
  padding: 10px 20px;
  font-size: 17px;
  font-weight: bold;
  width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body2 {
  padding: 20px;
  color: #333;
}
.mt-10 {
  margin-top: 10px;
}

.btn {
  margin-left: 5px;
}
.title{
    background: #285475;
    color:#fff;
    width: 200px;
    margin: 0 auto;
    font-size: 20px;
    text-align: center;
    padding: 10px 0px;
   border-radius: 0px 0px 15px 15px;

}
.custom-control-inline {
    display: -ms-inline-flexbox;
    display: -webkit-inline-box;
    display: inline-flex;
    margin-right: 1rem;
    display: -webkit-box;
}

@media only screen and (max-width: 600px) {
  .panal-header{
       width: 90% !important;
  }
  .app-stu-photo {
  float: none;

 
 
}
}
</style>